const zh = {
  nav: {
    aiSupportDemo: "AI 客服助手",
    howItWorks: "使用流程",
    industries: "行业模板",
    startFreeDemo: "免费体验",
  },
  landing: {
    heroTitle: "用 AI 重塑您的客户服务",
    heroSubtitle:
      "只需几分钟，体验 AI 如何处理客户咨询。上传文档或选择预置模板，无需注册。",
    startFreeDemo: "免费体验",
    learnMore: "了解更多",
    benefits: {
      noSignup: "无需注册",
      freeTry: "免费体验",
      dataSecure: "数据安全保障",
      twoMinutes: "2 分钟快速上手",
    },
    howItWorksTitle: "使用流程",
    howItWorksSubtitle: "三步快速上手，无需任何技术背景。",
    features: {
      uploadTitle: "上传文档",
      uploadDesc:
        "上传您的常见问题、产品文档或知识库文件，支持 PDF、Word、Markdown 和文本格式。",
      aiLearnsTitle: "AI 即时学习",
      aiLearnsDesc: "AI 秒级处理您的文档，为您的业务定制专属智能客服。",
      startChattingTitle: "开始对话",
      startChattingDesc:
        "用真实客户问题测试 AI，查看它如何基于您的文档给出准确、有帮助的回答。",
    },
    industryTemplatesTitle: "行业模板",
    industryTemplatesSubtitle: "暂无文档？试试我们预置的行业演示。",
    industries: {
      ecommerce: "电商",
      ecommerceDesc: "商品咨询、订单、退换货",
      saas: "SaaS",
      saasDesc: "功能指南、账单、技术支持",
      healthcare: "医疗健康",
      healthcareDesc: "预约挂号、保险、健康信息",
      financial: "金融服务",
      financialDesc: "账户信息、贷款、业务咨询",
      education: "教育",
      educationDesc: "课程、招生、校园服务",
    },
    trust: {
      secureTitle: "安全可靠",
      secureDesc: "您的文档经过安全处理，不会被永久存储。",
      instantTitle: "极速启动",
      instantDesc: "从上传到对话，60 秒内完成。",
      gptTitle: "DeepSeek · Qwen 驱动",
      gptDesc: "企业级 AI，由 DeepSeek 与 Qwen 强力驱动，提供准确、有用的回答。",
    },
    stats: {
      concurrentNum: "1000+",
      concurrentLabel: "同时服务客户数",
      resolutionNum: "98%",
      resolutionLabel: "问题解决率",
      responseNum: "3秒",
      responseLabel: "平均响应时间",
      availabilityNum: "24/7",
      availabilityLabel: "全天候服务",
    },
    features6Tag: "核心功能",
    features6Title: "为什么选择 AI 客服助手？",
    features6Subtitle: "基于大语言模型技术，深度融合企业工作流，打造真正智能的客户服务体验。",
    features6: {
      f1Title: "千人并发服务",
      f1Desc: "单账号可同时处理1000+客户咨询，无需排队等待，大幅提升客户满意度。",
      f2Title: "大模型驱动",
      f2Desc: "基于先进的大语言模型，理解复杂问题，给出精准回答，告别模板化回复。",
      f3Title: "企业知识库",
      f3Desc: "AI深度理解企业文档，构建向量知识库，确保回答准确、专业、符合企业规范。",
      f4Title: "语义理解",
      f4Desc: "真正理解客户意图，而非关键词匹配，支持多轮对话和上下文关联。",
      f5Title: "企业微信集成",
      f5Desc: "无缝对接企业微信，无需改变客户使用习惯，一键接入现有客服体系。",
      f6Title: "数据分析洞察",
      f6Desc: "实时监控服务质量，分析客户咨询热点，助力企业持续优化服务策略。",
    },
    testimonialsTag: "客户案例",
    testimonialsTitle: "深受行业领先企业信赖",
    testimonialsSubtitle: "看看他们如何用 AI 客服助手重塑客户服务体验。",
    testimonials: {
      t1Text: "接入AI客服后，我们的客服团队效率提升了300%。以前需要10个人处理的咨询量，现在3个人就能轻松应对，而且客户满意度还提高了。",
      t1Author: "张经理",
      t1Role: "某电商平台 客服总监",
      t2Text: "最让我惊喜的是AI对企业知识的理解能力。上传了上百页的产品手册后，AI不仅能准确回答客户问题，还能主动推荐相关产品。",
      t2Author: "李总",
      t2Role: "某SaaS公司 创始人",
      t3Text: "7×24小时不间断服务解决了我们的大问题。海外客户再也不用等国内上班时间，随时都能得到专业回复，大大提升了客户体验。",
      t3Author: "王主管",
      t3Role: "某跨境电商 运营主管",
    },
    ctaTitle: "准备好升级您的客户服务了吗？",
    ctaSubtitle: "加入数千家企业，用 AI 提供更快、更准确的客户服务。",
    ctaButton: "开始免费演示",
    footer: "无限开源科技 · 保留所有权利。",
  },
  demoSelector: {
    title: "您想如何体验演示？",
    subtitle: "选择最适合您的方式，两种方式均免费，2 分钟内即可完成。",
    upload: {
      title: "上传您的文档",
      description:
        "上传您的常见问题、产品文档或知识库文件，查看 AI 如何处理您的客服场景。",
      action: "选择文件",
      features: {
        formats: "支持 PDF、Word、Markdown",
        multiple: "支持多个文件",
        relevant: "最贴近实际的体验",
      },
    },
    template: {
      title: "使用模板演示",
      description: "选择预置的行业场景，无需文档，立即开始对话。",
      action: "浏览模板",
      features: {
        templates: "5 个行业模板",
        instant: "即时启动",
        realistic: "真实场景",
      },
    },
    recommended: "推荐",
    tip: "提示：上传您自己的文档，获得最贴近您业务的体验。",
  },
  upload: {
    title: "上传文档",
    back: "返回",
    pageTitle: "上传您的知识库",
    pageSubtitle: "上传您的常见问题、产品文档或任何客服资料，AI 将即时学习。",
    dropZoneTitle: "拖拽文件至此或点击浏览",
    dropZoneSubtitle: "支持 PDF、DOCX、MD、TXT（每个最大 {{size}}）",
    filesCount: "文件（{{count}}/{{max}}）",
    clearAll: "清除全部",
    uploading: "上传中...",
    processing: "处理中...",
    filesReady: "{{count}}/{{total}} 个文件就绪",
    cancel: "取消",
    uploadAndContinue: "上传并继续",
    errors: {
      noValidFile: "请至少添加一个有效文件。",
      tooManyFiles: "最多只能上传 {{max}} 个文件。",
      fileTooLarge: "文件大小超过 {{size}}",
      invalidType: "文件类型无效，仅支持 PDF、DOCX、MD 和 TXT。",
    },
  },
  rateLimit: {
    title: "演示次数已达上限",
    message: "您本小时的演示次数已用完。对将此方案用于您的业务感兴趣吗？",
    contactUs: "联系我们",
    tryLater: "稍后再试",
  },
  templateGallery: {
    headerTitle: "选择模板",
    title: "选择行业演示",
    subtitle: "选择预置场景，了解 AI 客服如何服务于您的行业。",
    loading: "加载模板中...",
    tryAgain: "重试",
    tryAsking: "试着问：",
    tryDemo: "开始演示",
    back: "返回",
    tipText:
      "想要更个性化的体验？上传您的文档，看看 AI 如何处理您的专属内容。",
    uploadDocsLink: "上传您的文档",
  },
  chat: {
    back: "返回",
    aiSupportDemo: "AI 客服助手",
    customKnowledge: "自定义知识库",
    templateDemo: "模板演示",
    getThisForBusiness: "为您的企业获取方案",
    typeMessage: "输入您的消息...",
    send: "发送",
    disclaimer: "这是演示环境，回答基于上传的文档或模板内容生成。",
    source: "来源：{{document}}",
    welcomeUpload:
      "您好！我是您的 AI 客服助手，已学习您上传的文档，随时为您解答相关问题。请问有什么可以帮助您的？",
    welcomeTemplate:
      "您好！我是{{industry}}领域的 AI 客服助手，已基于行业专属文档进行训练，随时为您提供帮助。请问有什么可以帮您？",
  },
  suggestedQuestions: {
    ecommerce: {
      q1: "你们的退货政策是什么？",
      q2: "如何追踪我的订单？",
      q3: "配送需要多长时间？",
      q4: "我可以取消或修改订单吗？",
    },
    saas: {
      q1: "如何重置密码？",
      q2: "Pro 计划包含哪些功能？",
      q3: "如何取消订阅？",
      q4: "是否有免费试用？",
    },
    healthcare: {
      q1: "如何预约挂号？",
      q2: "你们接受哪些保险？",
      q3: "如何查看我的病历？",
      q4: "门诊时间是什么时候？",
    },
    financial: {
      q1: "如何开设新账户？",
      q2: "目前的贷款利率是多少？",
      q3: "如何挂失卡片？",
      q4: "电汇手续费是多少？",
    },
    education: {
      q1: "你们提供哪些课程？",
      q2: "如何申请入学？",
      q3: "有哪些助学金选项？",
      q4: "如何使用学生服务？",
    },
    upload: {
      q1: "你们提供哪些服务？",
      q2: "如何开始使用？",
      q3: "营业时间是什么时候？",
      q4: "如何联系客服？",
    },
  },
  leadCapture: {
    title: "准备好升级您的客户服务了吗？",
    description:
      "您已体验演示 {{duration}}，共提问 {{count}} 次。让我们探讨如何满足您的具体需求。",
    thankYouTitle: "感谢您！",
    thankYouDesc: "我们已收到您的信息，将尽快与您联系。欢迎继续体验演示！",
    continueDemo: "继续体验",
    getMoreInfo: "获取更多信息",
    bookCall: "预约通话",
    submitting: "提交中...",
    fields: {
      name: "姓名",
      email: "工作邮箱",
      company: "公司",
      phone: "电话",
      message: "您最感兴趣的是什么？",
      optional: "（可选）",
      consent: "我同意隐私政策，并允许就 AI 客服解决方案与我联系。",
    },
    placeholders: {
      name: "张三",
      email: "zhangsan@company.com",
      company: "示例公司",
      phone: "+86 138 0000 0000",
      message: "请告诉我们您的使用场景或任何问题...",
    },
    errors: {
      nameRequired: "请填写姓名",
      emailRequired: "请填写邮箱",
      emailInvalid: "请输入有效的邮箱地址",
      companyRequired: "请填写公司名称",
      consentRequired: "请同意隐私政策",
    },
    continueDemoArrow: "继续体验 →",
  },
}

export default zh
